import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiMapPin, FiChevronDown, FiTruck } from 'react-icons/fi';
import { useShopStore, useSettingsStore } from '../../store';
import { ROUTES } from '../../utils';
import './ShopSwitcher.css';

function ShopSwitcher({ collapsed }) {
  const [isOpen, setIsOpen] = useState(false);
  const { selectedShop, availableShops, setSelectedShop } = useShopStore();
  const { loadSettings } = useSettingsStore();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (!selectedShop) return null;

  const handleSelectShop = (shop) => {
    setSelectedShop(shop);
    loadSettings(true);
    setIsOpen(false);
    navigate(ROUTES.DASHBOARD);
  };

  return (
    <div className="container-shopswitcher" ref={dropdownRef}>
      <button
        className="trigger-shopswitcher"
        onClick={() => setIsOpen(!isOpen)}
        title={collapsed ? selectedShop.name : undefined}
      >
        <span className="trigger-icon-shopswitcher">
          <FiMapPin />
        </span>
        {!collapsed && (
          <>
            <span className="trigger-text-shopswitcher">
              {selectedShop.name}
            </span>
            <FiChevronDown className={`trigger-chevron-shopswitcher ${isOpen ? 'open-shopswitcher' : ''}`} />
          </>
        )}
      </button>

      {isOpen && (
        <div className="dropdown-shopswitcher">
          <div className="dropdown-label-shopswitcher">Cambiar taller</div>
          {availableShops.map((shop) => (
            <button
              key={shop._id}
              className={`dropdown-item-shopswitcher ${shop._id === selectedShop._id ? 'active-shopswitcher' : ''}`}
              onClick={() => handleSelectShop(shop)}
            >
              <span className="item-logo-shopswitcher">
                {shop.logo ? (
                  <img src={shop.logo} alt={shop.name} />
                ) : (
                  <FiTruck />
                )}
              </span>
              <span className="item-name-shopswitcher">{shop.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default ShopSwitcher;
